<div class="toaster-container snackbar-shadow border-radius-8 margin-bottom overview-card no-background-color">
    <div *ngIf="toastData.toastrType != toastrTypes.simpleToastr" class="position-relative">
        <div class="position-absolute close-toast-icon cursor-pointer high-elevated" (click)="closeIcon()">
            <mat-icon class="font-16 pad-8-left">close</mat-icon>
        </div>
    </div>
    <div class="width-95" [ngClass]="toastData.button ? 'pad-4-top': 'padding-vr' ">
        <div class="custom-toaster__title-row pad-8">
            <div class="icon-wrapper flex-centered-container custom-toaster__icon" [class]="toastData.iconDetail.iconClass">
                <mat-icon>{{toastData.iconDetail.icon}}</mat-icon>
            </div>
            <div class="custom-toaster__title font-16 font-bold" [ngClass]="getToastClass()">{{toastData.title}}</div>
        </div>
        <div *ngIf="toastData.message" class="font-14 description pad-8-bottom">
            {{ toastData.message }}
        </div>
    </div>

    <div class="align-end">
        <div class="flex-centered-container-vr cursor-pointer font-12 negative-light border-radius-diagonal-8 pad-4-vr padding-hr"
            *ngIf="toastData.button" (click)="navigateToDetails()">
            <span class="pad-4-right"> {{ toastData.button.desc }}</span>
            <mat-icon>arrow_right_alt</mat-icon>
        </div>
    </div>
</div>